<template>
    <div :class="{marques:!$store.state.isMobile,mmarques:$store.state.isMobile,}">
        <div v-for="(item,i) in list" :key="i" class="vendeur">
            <div @click.stop="onClickVendeurInfo(item)">
                <vendeur-info-board :vendeurData="item" class="vendeurInfoBoardItem"></vendeur-info-board>
            </div>
            <div v-if="item.img && item.img.length>0">
                <img v-lazy="items.url" alt v-for="(items,indexs) in item.img" :key="indexs"
                     style="width: 25%;cursor: pointer"
                     @click="$router.push(`/ProductDetail?id=${items.id_produit}&vendu_par=${items.vendu_par}&vid=${items.id_vendeur}&categorie_id=${items.id_categorie}`)"
                />
            </div>
        </div>
        <!-- <goodsList @goDetail='goDetail' :rows='rows' :list="item.imgArr" type="0" ></goodsList> -->
    </div>
    </div>
</template>
<script>
import goodsList from "../../components/goodsList";
import vendeurInfoBoard from "../../components/vendeurInfoBoard";

export default {
    name: "Favoris",
    components: {
        goodsList,
        vendeurInfoBoard
    },
    data() {
        return {
            rows: 4,
            datamun: 0,
            apiCount: 0,
            // current: 1,
            description: "", //商家描述
            catalogues: [], //商家经营目录
            more: null,
            show: false,
            value: "",
            list: [],
            dataList: []
        };
    },
    created() {
        this.getProduct();
    },
    methods: {
        getSelect(val) {
            console.log(val);
        },
        tabCurrent(data, count) {
            data.current = count;
            this.$forceUpdate()
        },
        diaShow(data) {
            // console.log(data)
            if (data.img && data.img.length > 0) {
                if (!data.show) {
                    for (let i = 0; i < this.list.length; i++) {
                        this.list[i].show = false;
                    }
                    data.show = true;
                } else {
                    data.show = false;
                }
            }
            this.$forceUpdate()
            // console.log(this.list);
        },
        getProduct() {
            let userId = localStorage.getItem("id_acheteur")
                ? localStorage.getItem("id_acheteur")
                : null;
            this.$api.vendeurs.list({id_acheteur: userId, favoris: 1}).then(res => {
                this.list = res.data.result;
                this.datamun = this.list.length;
                this.getProduction();
            });
        },
        //获取折扣
        getDiscount(item, num) {
            this.$api.order
                .getDiscount({
                    page: 1,
                    pageSize: "100",
                    remiseType: "remise",
                    isCollect: item[0].isCollect,
                    idVendeur: item[0].id_vendeur
                })
                .then(res => {
                    this.list[num].discountList = res.data.list;
                });
            this.$forceUpdate()
        },
        getProduction() {
            if (this.apiCount >= this.datamun) {
                this.$forceUpdate();
                return;
            }
            this.$api.order.getProduction({
                page: 1,
                pageSize: 4,
                type: "newArriavl",
                id_vendeur: this.list[this.apiCount].id_vendeur
            })
                .then(res => {
                    let datas = res.data.list;
                    for (var i = 0; i < datas.length; i++) {
                        datas[i].url = `${this.$common.imgHost}Images/Boutiques/${datas[i].id_vendeur}/Produits/fiche/${datas[i].id_produit}-c.jpg`;
                    }
                    if (datas) this.list[this.apiCount].img = datas;
                    this.list[this.apiCount].show = false;
                    this.list[this.apiCount].current = 1;
                    let nums = this.apiCount;
                    if (datas && datas.length > 0) this.getDiscount(datas, nums);
                    this.getMore(this.list[nums].id_vendeur, nums);
                    this.apiCount++;
                    this.getProduction();
                    this.$forceUpdate()
                    // this.list = this.dataList
                    // console.log(this.list)
                });
        },
        getMore(vid, num) {
            let th = this;
            let description = "";
            this.$api.order.getMore(vid).then(res => {
                th.list[num].catalogues = res.data_vendeurs_catalogues;
                th.list[num].more = res;
                res.vendeurs_langues.forEach(item => {
                    description += item.description;
                });
                th.list[num].description = description;
            });
            this.$forceUpdate()
        },
        //点击图标进行跳转到商户页面
        onClickVendeurInfo(item) {
            this.$router.push({path: `/vendeur/${item.id_vendeur}`})
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Favoris/Vendeurs.less">
</style>

